import { noticesApi, resolveWpRequestLocale } from '@/lib/api'
import { notice, type NoticeModel, type RawNotice } from '@/models/notice'

export const NoticeService = {
  async notices(): Promise<NoticeModel[]> {
    const locale = resolveWpRequestLocale()
    const { data } = await noticesApi.get<RawNotice[] | { notices?: RawNotice[] }>('notices')
    const items = Array.isArray(data) ? data : data.notices ?? []

    return items
      .map((item) => notice(item, locale))
      .filter((item): item is NoticeModel => item !== null)
      .filter((item) => !item.locale || item.locale === locale)
  },
}
